module.exports = __webpack_public_path__ + "static/blobberconcept-87f9c4b546f4cc5ae624fa73fc81955f.svg";